import { debounce } from "../../utils";

class GrowthLatest {
    constructor(el) {
        if (!el) throw new Error('Element is not provided to GrowthLatest.');
        this.el = el;
        this.cards = Array.from(this.el.querySelectorAll('.custom-slide'));
        if (!this.cards.length) return console.warn('No custom slides found in provided element.');
        this.breakPoints = {
            one: 640,
            two: 860,
            three: 1100,
        };
        this.init();
    }

    init() {
        const debouncedResize = debounce(this.handleResize.bind(this), 250);
        this.handleResize();
        window.addEventListener('resize', debouncedResize);
    }

    handleResize() {
        const width = window.innerWidth;
        let breakPoint;
        if (width < this.breakPoints.one) {
            breakPoint = 'breakpointOne';
        } else if (width < this.breakPoints.two) {
            breakPoint = 'breakpointTwo';
        } else if (width < this.breakPoints.three) {
            breakPoint = 'breakpointThree';
        } else {
            breakPoint = 'breakpointFour';
        }
        this.insertCards(breakPoint);
    }

    insertCards(breakPoint) {
        const parent = this.el.querySelector('.swiper-wrapper');
        if (!parent) return console.warn('No swiper-wrapper found in provided element.');

        this.cards.forEach(card => {
            const position = parseInt(card.dataset[breakPoint]);
            if (isNaN(position) || position < 0 || position > parent.children.length) {
                console.warn(`Invalid position value found for breakPoint: ${breakPoint}`);
                return;
            }

            let insertPosition = position - 1;
            if (insertPosition >= parent.children.length) {
                insertPosition = parent.children.length - 1;
            }

            parent.insertBefore(card, parent.children[insertPosition]);
        });
    }
}

export default GrowthLatest;
